export default function MySQL_RIGHT() {
  return (
    <div>
      <h2>MySQL_RIGHT</h2>    </div>
  );
}